// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"225":"2721055c","354":"15bcfe4f","418":"6b8ca7b2"}[chunkId] + ".js";
};